<div class="image__uploader p-2">
  <div class="app__close--icon mr-[15px] mt-[10px]">
    <button matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
      <span class="material-icons" style="position: relative">clear</span>
    </button>
  </div>

  <!-- <div class="closebuttonMobile">
  <button type="button" class="close add-close-button" (click)="closeDialog()">
    <i class="material-icons" style="font-size: 34px">close</i>
  </button>
</div> -->

@if (loginStateObject) {
  <h3 class="image__uploader--title sm:mt-[40px] mt-[80px]">Add My Profile Picture</h3>
}

<div class="image__uploader--dropzone p-4">
  @if (!showdiv && !imageUploadedSuccess) {
    <div>
      <div class="image__uploader--dropzone--img">
        <img mat-card-image src="../../../assets/images/profile-placeholder.png" alt="Profile Image" class="h-[180px]" />
      </div>
    </div>
  }

  @if (format == 'image') {
    <div>
      <div class="mx-auto">
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [containWithinAspectRatio]="containWithinAspectRatio"
          [aspectRatio]="1"
          [resizeToWidth]="180"
          [resizeToHeight]="180"
          [onlyScaleDown]="true"
          [roundCropper]="true"
          [canvasRotation]="canvasRotation"
          [transform]="transform"
          [alignImage]="'center'"
          [style.display]="showCropper ? null : 'none'"
          format="jpeg"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady($event)"
          (loadImageFailed)="loadImageFailed()"
          class="w-[180px] h-[180px] min-w-[180px] min-h-[180px]"
        ></image-cropper>
      </div>
    </div>
  }

  @if (loginStateObject && imageUploadedSuccess && !showdiv) {
    <div class="image__uploader--dropzone--img">
      <img mat-card-image [src]="this.loginStateObject.profile_image_url" alt="Profile Image" style="border-radius: 100%; height: 180px" />
    </div>
  }
  <div class="flex justify-center mt-7">
    <button type="submit" class="image__uplader--upload--img" style="border: 1px solid #25508e" (click)="fileUpload.click()">
      <img src="../../../../assets/images/upload.svg" />
      Upload Image
    </button>
  </div>

  <input type="file" style="display: none" #fileUpload (change)="fileChangeEvent($event)" id="fileUpload" name="fileUpload" />
</div>

<div
  class="edit__profile-footer sm:mt-[25px] mt-0 sm:ml-[-8px] sm:mr-[-8px]"
  [style]="screenWidth > 640 ? 'box-shadow: -2px -1px 15px rgba(0, 0, 0, 0.1); border-radius: 0px 0px 16px 16px' : ''"
  >
  @if (data.triggeredFrom == 'continueBtn') {
    <button class="app__skip-btn mr-2" (click)="addContactInformation('contactInfo')">Skip</button>
  }
  <button
    mat-raised-button
    class="w-[226px] h-[48px]"
    [class]="this.croppedImage || this.format ? 'app__btn--primary--medium' : 'app__btn--disabled--medium'"
    (click)="(this.croppedImage || this.format) && uploadFiles()"
    >
    {{ data.triggeredFrom == 'continueBtn' ? 'Save and Continue' : 'Save' }}
  </button>
</div>
</div>
@if (showLoader) {
  <div>
    <div class="loading-spinner loader-overlay">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}

<!-- <div class="dialog-container">
<div class="web-close-icon">
  <button
    matTooltipPosition="above"
    data-dismiss="modal" (click)="closeDialog()" class="web-close-btn">
    <span class="material-icons " style="position: relative;">clear</span>
  </button>
</div>

<div class="closebuttonMobile">
  <button type="button" class="close add-close-button" (click)="closeDialog()">
    <i class="material-icons" style="font-size: 34px;">close</i>
  </button>
</div>

<h3 *ngIf="loginStateObject && imageUploadedSuccess && !showdiv" class="addPhotoText">Update Photo</h3>

<h3 *ngIf="(format && croppedImage) || (!showdiv && !imageUploadedSuccess)" class="addPhotoText">Add Photo</h3>

<mat-divider class="dividerOnMobile"></mat-divider>
<div class="container">

  <div *ngIf="!showdiv && !imageUploadedSuccess">

    <h2 class="zerostateTextWeb">Add a face to your name and</h2>

    <h2 class="zerostateTextWeb">Let people know that it's really you</h2>

    <div class="zerostateImageWeb">
      <img mat-card-image src="../../../assets/images/uploadImageZero.png"  alt="Profile Image">
    </div>

    <div class="zerostateImageMobile">
      <div class="mobileResImage">
        <img mat-card-image src="../../../assets/images/uploadZeroImageMobile.png"  alt="Profile Image" style="max-width:100%;">
      </div>
    </div>

    <div class="zerostateTextmobile">
      <div class="mobileResText">
        <h2>Add a face to your name and</h2>
        <h2>Let people know that it's really you</h2>
      </div>
    </div>

    <p style="text-align: center;color:rgba(0,0,0,0.6);font-size: 12px;font-weight: 600;line-height: 25px;"></p>


  </div>

  <div *ngIf="format == 'image'" class="mt-4">

    <div>
      <image-cropper
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true"
        [containWithinAspectRatio]="containWithinAspectRatio"
        [resizeToWidth]="resizeToWidth"
        [cropperMinWidth]="cropperMinWidth"
        [onlyScaleDown]="true"
        [roundCropper]="true"
        [canvasRotation]="canvasRotation"
        [transform]="transform"
        [alignImage]="'center'"
        [style.display]="showCropper ? null : 'none'"
        format="jpeg"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady($event)"
        (loadImageFailed)="loadImageFailed()"

      ></image-cropper>
    </div>
  </div>

  <div *ngIf="loginStateObject && imageUploadedSuccess && !showdiv" class="uploadedImageWrapper">
    <p>{{imageUploadedSuccess}}</p>
    <img mat-card-image [src]="this.loginStateObject.profile_image_url"  alt="Profile Image" class="uploadedImage">
  </div>

  <div id="showonlyOnMobile">
    <div class="action" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
      <button
        type="submit"
        class="info"
        style="width: 68%;height:32px;font-family: Open Sans;font-weight: bold;font-size: 12px;line-height: 16px;text-transform: uppercase;color: #FFFFFF;"
        (click)="fileUpload.click()"
        >
        <span class="fa fa-paperclip" style="margin-right:5px !important"></span> Choose File
      </button>

      <input type="file" style="display: none;" #fileUpload (change)="fileChangeEvent($event)" id="fileUpload" name="fileUpload" />
      <button
        type="submit"
        class="info"
        style="width: 68%;height:32px;font-family: Open Sans;font-weight: bold;font-size: 12px;line-height: 16px;text-transform: uppercase;color: #FFFFFF;margin-top: 20px;"
        *ngIf="format && croppedImage" (click)="uploadFiles()"
        >
        Upload
      </button>
    </div>
  </div>

</div>

<div class="action modal-footer" id="uploadButtonWeb">
  <button
    type="submit"
    class="info"
    style="width: 136px;height:32px;font-family: Open Sans;font-weight: bold;font-size: 12px;line-height: 16px;text-transform: uppercase;color: #FFFFFF;"
    (click)="fileUpload.click()"
    >
    <span class="fa fa-paperclip" style="margin-right:5px !important"></span> Choose File
  </button>
  <input type="file" style="display: none;" #fileUpload (change)="fileChangeEvent($event)" id="fileUpload" name="fileUpload" />

  <button
    type="submit"
    class="info"
    style="width: 136px;height:32px;font-family: Open Sans;font-weight: bold;font-size: 12px;line-height: 16px;text-transform: uppercase;color: #FFFFFF;"
    *ngIf="format && croppedImage" (click)="uploadFiles()"
    >
    Upload
  </button>

</div>
</div>
<div *ngIf="showLoader" >
  <div class="loading-spinner loader-overlay">
    <mat-spinner></mat-spinner>
  </div>
</div>    -->
